import React, { useState } from "react";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Grow from "@material-ui/core/Grow";
import Paper from "@material-ui/core/Paper";
import Popper from "@material-ui/core/Popper";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import { makeStyles } from "@material-ui/core/styles";
import { Collapse, Divider, Icon } from "@material-ui/core";
import {
  ROUTE_ACTION_RESOLUTION,
  ROUTE_ADMIN_CAMPAIGN,
  ROUTE_ADMIN_FILE_MANAGEMENT,
  ROUTE_ADMIN_WORKSHOPS,
  ROUTE_CONTRACT_DATA,
  ROUTE_ENTRY_CHANNEL,
  ROUTE_EXCEPTIONS,
  ROUTE_EXTERNAL_USERS,
  ROUTE_INTERACTION,
  ROUTE_MAIL_MAPPERS,
  ROUTE_SERVICES,
  ROUTE_STATES,
  ROUTE_SUBSTATES,
  ROUTE_TAXONOMIES,
  ROUTE_TEMPLATES,
  ROUTE_USERS,
} from "../routes/routesConstants";
import { isUserInRole } from "../../commonFunctions/commonFunctions";
import { ADMIN } from "../../Constantes/userRoles";
import { useSelector } from "react-redux";
import {
  selectUserRoles,
  selectUserSuperAdmin,
} from "../../redux/authentication/selectors";
import arrowRight from "../../images/arrow-right.svg";
import arrowDown from "../../images/arrow-down.svg";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles(() => ({
  paper: {
    borderRadius: 0,
    width: "200px",
  },
  listItemNested: {
    paddingLeft: "2rem",
    "&:hover": {
      backgroundColor: "#e0e2e5",
    },
  },
  divider: {
    backgroundColor: "#fff",
    opacity: ".5",
  },
}));

function AdminMenu(props) {
  const { t } = useTranslation();
  const { anchor, open, handleClose, handleMenuClick } = props;
  const [openNestedMenu, setOpenNestedMenu] = useState(false);
  const classes = useStyles();
  const userRoles = useSelector(selectUserRoles);
  const userSuperAdmin = useSelector(selectUserSuperAdmin);

  const linkData = [
    {
      url: ROUTE_ENTRY_CHANNEL,
      text: t("EntryChannels"), //"Canais de entrada",
    },
    // {
    //   url: ROUTE_CONTRACT_DATA,
    //   text: t("ContractData"), //"Dados de Contrato",
    // },
    { url: ROUTE_MAIL_MAPPERS, text: t("IncomingEmails"), //"Emails Entrantes"
    },
    {
      url: ROUTE_STATES,
      text: t("States"), //"Estados",
    },
    // {
    //   url: ROUTE_SUBSTATES,
    //   text: t("Substates"), //"Subestados",
    // },
    // {
    //   url: ROUTE_EXCEPTIONS,
    //   text: t("Exceptions"), //"Exceções",
    // },
    {
      url: ROUTE_ACTION_RESOLUTION,
      text: "Resoluções", //"Interações",
    },
    {
      url: ROUTE_INTERACTION,
      text: t("Interactions"), //"Interações",
    },
    {
      url: ROUTE_TEMPLATES,
      text: t("templates"), //"Plantillas SMS/Email",
    },
    {
      url: ROUTE_SERVICES,
      text: t("Services"), //"Serviços",
    },
    
    // {
    //   url: ROUTE_ADMIN_WORKSHOPS,
    //   text: "Talleres",
    // },
    {
      url: ROUTE_TAXONOMIES,
      text: t("Taxonomies"), //"Taxonomías",
    },
    {
      url: ROUTE_USERS,
      text: t("Users"), //"Usuários",
    },
    {
      url: ROUTE_EXTERNAL_USERS,
      text: t("ExternalUsers"), //"Usuários Externos",
    },
  ];

  return (
    <Popper
      id="admin-popper"
      open={open}
      anchorEl={anchor.current}
      transition
      disablePortal
      placement={"bottom-start"}
    >
      {({ TransitionProps }) => (
        <Grow
          {...TransitionProps}
          style={{ transformOrigin: "left top", left: "0.25rem" }}
        >
          <Paper elevation={0} classes={{ root: classes.paper }}>
            <ClickAwayListener onClickAway={() => handleClose(false)}>
              <MenuList
                autoFocusItem={open}
                id="menu-list-grow"
                classes={{ root: classes.list }}
              >
                {/* <MenuItem
                  key={"Campanhas"}
                  onClick={() => {
                    handleMenuClick(ROUTE_ADMIN_CAMPAIGN);
                    handleClose(false);
                  }}
                  ListItemClasses={{ button: classes.button }}
                  target="_blank"
                  classes={{ root: classes.listItem }}
                >
                  {t("Campaigns")}
                </MenuItem> */}
                {isUserInRole(ADMIN, userRoles, userSuperAdmin) && (
                  <>
                    <MenuItem
                      button
                      ListItemClasses={{ button: classes.button }}
                      target="_blank"
                      classes={{ root: classes.listItem }}
                      onClick={() => !setOpenNestedMenu(!openNestedMenu)}
                    >
                      <span
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          width: "100%",
                        }}
                      >
                        <span>{t("MasterEditions")}</span>
                        <img
                          style={{ width: "0.625rem", height: "0.625rem" }}
                          className={"navbar-icon"}
                          src={openNestedMenu ? arrowDown : arrowRight}
                        />
                      </span>
                    </MenuItem>
                    <Collapse in={openNestedMenu} timeout="auto" unmountOnExit>
                      <MenuList>
                        {linkData.map((value, index, array) => [
                          <MenuItem
                            key={value.text}
                            ListItemClasses={{ button: classes.button }}
                            target="_blank"
                            classes={{ root: classes.listItemNested }}
                            onClick={() => {
                              handleMenuClick(value.url);
                              handleClose(false);
                            }}
                          >
                            {value.text}
                          </MenuItem>,
                          index < array.length - 1 && (
                            <Divider
                              key={"divider-" + index}
                              classes={{ root: classes.divider }}
                              component="li"
                            />
                          ),
                        ])}
                      </MenuList>
                    </Collapse>
                  </>
                )}
                {isUserInRole(ADMIN, userRoles, userSuperAdmin) && (
                  <MenuItem
                    key={"Importação CSV"}
                    onClick={() => {
                      handleMenuClick(ROUTE_ADMIN_FILE_MANAGEMENT);
                      handleClose(false);
                    }}
                    ListItemClasses={{ button: classes.button }}
                    target="_blank"
                    classes={{ root: classes.listItem }}
                  >
                    {t("CSVImport")}
                  </MenuItem>
                )}
              </MenuList>
            </ClickAwayListener>
          </Paper>
        </Grow>
      )}
    </Popper>
  );
}

export { AdminMenu };
